module.exports = __webpack_public_path__ + "img/deleteImageWhite.21205b50.svg";